<app-upload-box
  [options]="getUploadBoxOptions()"
  [showFileList]="false"
  [showUploadingBar]="uploadBox?.uploader?.queue.length <= 1"
  (complete)="onFilesUploaded($event)"
  direction="h"
  *ngIf="!(1 | isReadonlyRole)"
  image="/assets/images/upload-files.svg"
  #uploadBox
>
</app-upload-box>

<div class="file-list-wrapper" *ngIf="fileItemsCount">
  <div
    class="uploaded-file-list"
    *ngIf="uploadedFilesData.length"
    dragula="templateFiles"
    [(dragulaModel)]="uploadedFilesData"
    (dragulaModelChange)="onFileOrderChanged()"
  >
    <div *ngFor="let item of uploadedFilesData; let index = index; let count = count" class="file-upload-item shadow">
      <ng-container *ngIf="count + getUploadingFileItem()?.length > 1">
        <i class="cs-icon cs-icon-drag-handler drag-handler"></i>
        <span class="file-number">{{ index + 1 }}</span>
      </ng-container>
      <i [ngClass]="item.origin.name | fileIcon" class="file-icon"></i>
      <div class="file-info-wrapper">
        <div class="file-name">
          {{ item.origin.name }}
        </div>
        <div class="file-size">{{ item.origin.size | fileSize }}</div>
      </div>
      <a
        href="javascript:;"
        i18n-matTooltip
        matTooltip="Remove this file."
        class="btn btn-light-danger"
        (click)="onRemoveItem(index)"
      >
        <i class="cs-icon cs-icon-trash"></i>
      </a>
    </div>
  </div>
  <ng-container *ngIf="getUploadingFileItem() as fileItems">
    <div class="uploading-file-list" *ngIf="fileItems.length">
      <div *ngFor="let item of fileItems; let index = index; let count = count" class="file-upload-item shadow">
        <ng-container *ngIf="uploadedFilesData?.length + count > 1">
          <i class="cs-icon cs-icon-drag-handler drag-handler"></i>
          <span class="file-number">{{ uploadedFilesData.length + index + 1 }}</span>
        </ng-container>
        <i [ngClass]="item.file.name | fileIcon" class="file-icon"></i>
        <div class="file-info-wrapper">
          <div class="file-name">
            {{ item.file.name }}
          </div>
          <div class="file-size">{{ item.file.size | fileSize }}</div>
        </div>
        <a
          href="javascript:;"
          [disabled]="item.isUploading"
          i18n-matTooltip
          matTooltip="Upload"
          class="btn btn-light-info"
          (click)="item.upload()"
        >
          <i class="cs-icon cs-icon-upload"></i>
        </a>
        <ngb-progressbar
          *ngIf="item.isUploading"
          [striped]="true"
          [animated]="true"
          [value]="item.progress"
          type="success"
          class="file-progress"
        >
        </ngb-progressbar>
      </div>
    </div>
  </ng-container>
</div>
<div *ngIf="fileItemsCount > 1" class="text-center text-light" i18n>
  The selected files will be merged together in the following order. Click-and-drag to change the merge order.
</div>
